import { useCmpGlobalSettings } from "../../../hooks/useCmpSettingsSection";
import { normalizeCmpTimeZone } from "../../../utils/cmpTimeZones";
import { EMAIL_OPERATION_ERROR_CONTEXT } from "./emailBackendMappers";

/** Operational global settings expose the chamber time zone to email staff. */
export const useEmailTimeZone = (chamberId: string) => {
  const result = useCmpGlobalSettings(
    chamberId,
    "cache-and-network",
    EMAIL_OPERATION_ERROR_CONTEXT
  );
  const configured = result.data?.getChamberMemberProSettings?.setup?.timeZone;
  return {
    ...result,
    timeZone: configured ? normalizeCmpTimeZone(configured).timeZone : null,
  };
};
